module.exports = __webpack_public_path__ + "media/images/smart_phone/star-52bb7db947010286d05ceb0976dccfad.png";